// component
import ProjectDetails from '../../components/ProjectDetails';
import SocialIcon from '../../components/SocialIcon';

export default function Home({ projects, isPending, error }) {
  return (
    <section className="lg:animate-zoomPage flex flex-col lg:flex-row lg:max-h-[65vh]">
      <div className="flex-1 mb-14 md:px-7 md:pt-5 lg:px-10 lg:mb-0 ">
        <p className="font-monoBody text-accent text-2xl overflow-hidden tracking-widest inline-block whitespace-nowrap md:text-2xl animate-typing">
          Hello, my name is
        </p>
        <h2 className="text-ash-200 text-3xl mt-1 mb-1 font-bold md:text-4xl">
          Okechukwu Chidera
        </h2>
        <p className="text-ash-100 uppercase text-lg font-medium mb-2 md:text-xl">
          FrontEnd developer
        </p>

        <p className="text-ash-200 leading-8 text-xl mb-7 font-light md:text-xl md:leading-8">
          I’m a frontend developer, who builds responsive and SEO optimized web
          applications with HTML, CSS, JavaScript and frameworks such as React.
        </p>
        <SocialIcon />
      </div>
      <div className="lg:flex-[1.3] lg:overflow-y-auto overflow-x-hidden lg:bar ">
        {error && <p className="error">{error}</p>}
        {isPending && <p className="loading">Loading...</p>}
        {projects && <ProjectDetails projects={projects} />}
      </div>
    </section>
  );
}
